<div class="image-card-container" [ngClass]="[ isSmallScreen() ? 'column' : 'row', config().imagePosition || 'right']">
  <div class="description">
    <h1>{{ config().title }}</h1>
    @for(line of config().description.lines; track line) {
        <p>{{ line }}</p>
    } 

    @if (config().description.button) {
        @if (config().description.button?.link?.includes('http')){            
            <a [href]="config().description.button?.link" mat-flat-button class="button" [attr.target]="config().description.button?.target">
                {{ config().description.button?.text }}
            </a>
        } @else {
            <a [routerLink]="config().description.button?.link" mat-flat-button class="button" [attr.target]="config().description.button?.target">
                {{ config().description.button?.text }}
            </a>
        }
    }
  </div>

  <div class="picture-container">
    <div class="picture" [style.backgroundImage]="config().image ? 'url(' + config().image + ')' : ''" [style.backgroundSize]="config().backgroundSize"></div>
  </div>
</div>
